import { Suspense, lazy, useEffect, useState } from "react";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import { SellingCards } from "@/components/ui/sellingcards";

const ServicesPreview = lazy(() => import("@/components/ServicesPreview"));
const CtaBanner = lazy(() => import("@/components/CtaBanner"));
const Footer = lazy(() => import("@/components/Footer"));

const Index = () => {
  const [showDeferredSections, setShowDeferredSections] = useState(false);

  useEffect(() => {
    if (showDeferredSections) return;

    const enableDeferredSections = () => setShowDeferredSections(true);
    const onScroll = () => {
      if (window.scrollY > 160) {
        enableDeferredSections();
      }
    };

    const fallbackTimer = window.setTimeout(enableDeferredSections, 4000);

    window.addEventListener("scroll", onScroll, { passive: true });
    window.addEventListener("touchstart", enableDeferredSections, { passive: true, once: true });
    window.addEventListener("keydown", enableDeferredSections, { once: true });

    return () => {
      window.clearTimeout(fallbackTimer);
      window.removeEventListener("scroll", onScroll);
      window.removeEventListener("touchstart", enableDeferredSections);
      window.removeEventListener("keydown", enableDeferredSections);
    };
  }, [showDeferredSections]);

  return (
    <div className="min-h-screen">
      <Navbar />
      <Hero />
      {showDeferredSections && (
        <>
          <Suspense fallback={<div className="py-16" />}>
            <ServicesPreview />
          </Suspense>
          <Suspense fallback={<div className="py-8" />}>
            <CtaBanner />
          </Suspense>
          <Suspense fallback={<div className="py-8" />}>
            <SellingCards />
          </Suspense>
          <Suspense fallback={<div className="py-12" />}>
            <Footer />
          </Suspense>
        </>
      )}
    </div>
  );
};

export default Index;
